import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

export const PortfolioUsersMenu = ({
    currentEnterpriseId,
    showUsers,
    showRoles,
    showGroups,
    ...other
}: {
    currentEnterpriseId: string;
    showUsers: boolean;
    showRoles: boolean;
    showGroups: boolean;
}) => (
    <SidebarExpandableListItem
        leftIcon={<SidebarFontIcon value={IconName.Employees} />}
        primaryText={<LocalizedText textKey={TextKey.UsersAndRoles} />}
        value="usersAndRoles"
        {...other}
    >
        {showUsers && (
            <>
                {createListItemWithLink({
                    textKey: TextKey.UserPlural,
                    iconName: IconName.Employees,
                    path: 'UserManagement/MultiProperty/PropertyUsers/Index',
                    tooltip: null,
                    isMainItem: true,
                })}
            </>
        )}

        {showRoles &&
            createListItemWithLink({
                textKey: TextKey.Roles,
                iconName: IconName.Staff,
                path: 'Roles/Index',
                tooltip: null,
                isMainItem: true,
            })}

        {showGroups &&
            createListItemWithLink({
                textKey: TextKey.UserGroups,
                iconName: IconName.ReservationGroup,
                path: 'UserGroups/Index',
                tooltip: null,
                isMainItem: true,
            })}
    </SidebarExpandableListItem>
);
